var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0909 6.36363H3.10379L6.09737 9.35721C6.4524 9.71218 6.4524 10.2878 6.09737 10.6428C5.91986 10.8203 5.68719 10.9091 5.45452 10.9091C5.22186 10.9091 4.98919 10.8203 4.81173 10.6428L0.266273 6.09733C-0.0887585 5.74236 -0.0887585 5.16672 0.266273 4.81169L4.81173 0.266228C5.1667 -0.0887425 5.74234 -0.0887425 6.09737 0.266228C6.4524 0.621198 6.4524 1.19684 6.09737 1.55187L3.10379 4.54545H19.0909C19.593 4.54545 20 4.95248 20 5.45454C20 5.9566 19.593 6.36363 19.0909 6.36363Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.2879d599d6fe0aacfad7e75d3665a252.svg";
export { ForwardRef as ReactComponent };